/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/capital_1': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 12.336V4.25h-8.086L16 .586 12.336 4.25H4.25v8.086L.586 16l3.664 3.664v8.086h8.086L16 31.414l3.664-3.664h8.086v-8.086L31.414 16l-3.664-3.664zM14.5 14.5v-6h.75v6h1.5v-6h.75v12h-3v-6zM4.75 4.75h7.086L4.75 11.836V4.75zm0 22.5v-7.086l7.086 7.086H4.75zM17.5 23.5h-3v-.75h3v.75zm1.5-9.75V22h-6v-8.25h-.75v6.75h-3l3.75-9v2.25h.75v7.5h4.5v-7.5H19V11.5l3.75 9h-3v-6.75H19zm8.25 13.5h-7.086l7.086-7.086v7.086zm0-15.414L20.164 4.75h7.086v7.086z"/>'
  }
})
